export const urlTypes = [
    {
        id: 'internal',
        name: 'Internal',
    },
    {
        id: 'external',
        name: 'External',
    },
]

export const ctaStyles = [
    {
        id: 'light',
        name: 'Light',
    },
    {
        id: 'dark',
        name: 'Dark',
    },
]

export const languageDirections = [
    {
        id: 'ltr',
        name: 'Left to right',
    },
    {
        id: 'rtl',
        name: 'Right to left',
    },
]

export const navNodeStyles = [
    {
        id: 'link',
        name: 'Link',
    },
    {
        id: 'button',
        name: 'Button',
    },
]